import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

export interface ResAllNews {
  message: string;
  result: News[];
  success: boolean;
}

interface News {
  ALWAYS_OPEN: string;
  ADMIN_CREATEID: string;
  NEWS_CATEGORY: string
  NEWS_DATE: Date;
  NEWS_DETAIL: string;
  NEWS_END: Date;
  NEWS_ID: number;
  NEWS_PIC: string;
  NEWS_READED: number;
  NEWS_START: Date;
  NEWS_STATUS: number;
  NEWS_TITAL: string;
}

interface GetNews {
  message: string;
  result: {
    DETAIL_NEWS: News[];
    SUGGEST_NEWS: News[];
  }
  success: boolean;
}

interface ReadNews {
  message: string;
  result: {
    updatetime: Date;
  }
  success: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllNews() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<ResAllNews>(environment.URL + '/news/GetAllNews', { headers: headers });
  }

  getNews(newsId) {
    const headers = new HttpHeaders({ Authorization: this.token });
    const body = {
      NEWS_ID: newsId
    }

    return this.http.post<GetNews>(environment.URL + '/news/getDetailByNewsID', body, { headers: headers });
  }

  newsReadCountUpdate(newsId) {
    const headers = new HttpHeaders({ Authorization: this.token });
    const body = {
      NEWS_ID: newsId
    }

    return this.http.post<ReadNews>(environment.URL + '/news/readNewsById', body, { headers: headers });

  }
}
